import setDateAtAnotherDate from '@teetsh/app/src/utils/time/setDateAtAnotherDate';
import { Classroom } from 'types/classroom';
import _some from 'lodash-es/some';

export const changeStartEndBasedFromDate = ({ date, start, end }) => {
  const newStart = setDateAtAnotherDate(start, date);
  const newEnd = setDateAtAnotherDate(end, date);
  return {
    start: newStart,
    end: newEnd,
  };
};

export function hasAClassroomThatStartSunday(classrooms: Classroom[]): boolean {
  return _some(classrooms, cl => cl.workingDays.includes(-1));
}
